import { render } from "./eja.vue?vue&type=template&id=395fb146&scoped=true"
import script from "./eja.vue?vue&type=script&lang=js"
export * from "./eja.vue?vue&type=script&lang=js"

import "./eja.vue?vue&type=style&index=0&id=395fb146&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-395fb146"]])

export default __exports__